"use strict";

exports.__esModule = true;
var _OrderButtonSelector = require("./OrderButtonSelector");
Object.keys(_OrderButtonSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OrderButtonSelector[key]) return;
  exports[key] = _OrderButtonSelector[key];
});
var _OrderSelectorDefinition = require("./OrderSelectorDefinition");
Object.keys(_OrderSelectorDefinition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OrderSelectorDefinition[key]) return;
  exports[key] = _OrderSelectorDefinition[key];
});